import { useEffect, useMemo, useState } from 'react';

import useRoverBrandContext from '@rover/react-lib/src/context/useRoverBrandContext';
import { CountryConfiguration } from '@rover/rsdk/src/apiClient/latest';
import useCountryConfigurationShim from '@rover/shared/js/hooks/useCountryConfigurationShim';
import { RoverBrand, RoverBrandAriaLabel } from '@rover/types';

import { CatInAFlatLogo, RoverLogo } from '../logos';

const useBrandLinkData = (): {
  logoAriaLabel: RoverBrandAriaLabel;
  Logo: React.FC<React.SVGProps<SVGSVGElement>>;
  logoHref: string;
} => {
  const { brand } = useRoverBrandContext();
  const { current: cc = null, navigation: nc = null } = useCountryConfigurationShim();
  const [countryConfig, setCountryConfig] = useState<CountryConfiguration | null>(nc ?? cc);
  let Logo: React.FC<React.SVGProps<SVGSVGElement>>;
  let logoAriaLabel: RoverBrandAriaLabel;

  useEffect(() => {
    setCountryConfig(nc ?? cc);
  }, [nc, cc]);

  switch (brand) {
    case RoverBrand.CatInAFlat:
      Logo = CatInAFlatLogo;
      logoAriaLabel = RoverBrandAriaLabel.CatInAFlat;
      break;
    case RoverBrand.Rover:
    default:
      Logo = RoverLogo;
      logoAriaLabel = RoverBrandAriaLabel.Rover;
      break;
  }

  const logoHref = useMemo((): string => {
    const { urlPrefix } = countryConfig ?? {};
    if (!urlPrefix) return '/';
    return `/${urlPrefix}/`;
  }, [countryConfig]);

  return { logoAriaLabel, Logo, logoHref };
};

export default useBrandLinkData;
